import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import LatestNews from "./components/LatestNews";
import { siteInfo } from "@/mocks/siteInfo";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "51黑料网",
  url: "https://www.51heiliaowang.com",
  description: siteInfo.description,
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.51heiliaowang.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "51黑料网",
  url: "https://www.51heiliaowang.com",
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    "@type": "PostalAddress",
    streetAddress: "望京SOHO T3座 1808室",
    addressLocality: "北京",
    addressRegion: "朝阳区",
    addressCountry: "CN",
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="51黑料网 | 51黑料网今日黑料首页 | 今日黑料最新 黑料每日更新"
        description="51黑料网今日黑料首页，聚合每日最新黑料与八卦爆料，覆盖今日黑料最新、黑料每日更新及51黑料今日热点，快速获取新鲜黑料内容。"
        keywords="51黑料网,今日黑料,今日黑料首页,黑料每日更新,51黑料今日,黑料新鲜事,最新黑料,黑料入口,51黑料网入口,每日黑料"
        canonicalUrl="https://www.51heiliaowang.com/"
      />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <TrendingSection />
        <LatestNews />
      </main>

      <Footer />
    </>
  );
}